module.exports = __webpack_public_path__ + "media/images/emoticons/kissmark-2df04f9186c57c6998ff50446b4ba628.gif";